/* eslint-disable no-param-reassign */
import { register, load } from '@shopify/theme-sections';
Avatar.theme = Avatar.theme || {};

Avatar.theme.ProductRecommendations = function ProductRecommendations() {
  function init(container) {
    var productRecEvent = new Event('product-recommendations');
    var _container$dataset = container.dataset,
        baseUrl = _container$dataset.baseUrl,
        productId = _container$dataset.productId,
        limit = _container$dataset.limit,
        sectionType = _container$dataset.sectionType;
    var request = "\n      ".concat(baseUrl, "?section_id=").concat(sectionType, "&product_id=").concat(productId, "&limit=").concat(limit, "\n    ");
    fetch(request).then(function (res) {
      return res.text();
    }).then(function (productHtml) {
      if (productHtml.trim() === '') return;
      container.innerHTML = productHtml;
      container.innerHTML = container.firstElementChild.innerHTML;
      document.dispatchEvent(productRecEvent);
    });
  }

  return {
    init: init
  };
}();

register('product-recommendations', {
  onLoad: function onLoad() {
    Avatar.theme.ProductRecommendations.init(this.container);
  }
});
load('product-recommendations');